import React from 'react';
import PropTypes from 'prop-types';

const NotFound = ({ viewer }) => (
  <div style={{ textAlign: 'center', marginTop: '120px', fontSize: '1rem' }}>
    <h1>
      Page not found
    </h1>
    {!viewer && <p>You may need to <a href='/login'>log in</a> to see this page</p>}
  </div>
);

NotFound.propTypes = {
  viewer: PropTypes.object
};

export default NotFound;



// WEBPACK FOOTER //
// ./webpack/components/App/404.js